import { useLocation, useSearchParams } from 'react-router-dom'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/analytics/configTableOrder'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_ORDER } from 'services/apiAnalyticOrder'
import { Alert } from 'avo-ui'
import { Order } from 'components/analytics/order/Order'
import { INITIAL_ADVANCE_FILTER } from 'configs/analytics/configTableOrder'
import { FILTER_PARAMS } from 'configs/analytics/configTableOrder'

export const OrderContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [queryFilter, setQueryFilter] = useState(INITIAL_ADVANCE_FILTER)
    const [queryList, setQueryList] = useState({})
    const { fetching: getOrderGraph, data: orderGraph, isLoading: isLoadingGraph } = useFetch(API_ORDER.GRAPH)
    const { fetching: getOrderList, data: orderList, isLoading: isLoadingList } = useFetch(API_ORDER.LIST)
    const { fetching: exportOrderList, isLoading: isLoadingExport } = useFetch(API_ORDER.EXPORT)
    const {
        fetching: getOrderComparison,
        data: orderComparison,
        isLoading: isLoadingComparison,
    } = useFetch(API_ORDER.COMPARISON)
    const [modal, setModal] = useState({
        filter: false,
        export: false,
    })

    const getQuery = () => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INITIAL_ADVANCE_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS?.includes(key) && key !== 'voucher_codes') {
                const valueOfQuery = item?.split(',')
                newQueryFilter[key] = valueOfQuery
                currentQuery[key] = valueOfQuery
            } else if (key === 'voucher_codes') {
                const splitObject = item?.split('|')
                const parseObject = splitObject?.map((i) => JSON.parse(i))
                newQueryFilter[key] = parseObject
                currentQuery[key] = parseObject?.map((i) => i?.value)
            }
        })

        return { currentQuery, newQueryFilter }
    }

    useEffect(() => {
        const { page, limit, search, ...queryRest } = getQuery()?.currentQuery
        getOrderGraph(queryRest)
        getOrderComparison(queryRest)
    }, [query?.start_date, query?.end_date, query?.voucher_codes, query?.payment_services, query?.shipping_aliases])

    useEffect(() => {
        const { currentQuery, newQueryFilter } = getQuery()
        setQueryFilter({ ...queryFilter, ...newQueryFilter })
        setQueryList(currentQuery)
        getOrderList(currentQuery)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryAdvanceFilter(filter)
        onChangeQuery({
            ...queryFilter,
            search: '',
            page: 1,
            limit: 20,
        })
        setShowModal({ filter: false })
    }

    const getQueryAdvanceFilter = (filter) => {
        const queryFilter = { ...filter }
        Object.entries(queryFilter).forEach(([key, item]) => {
            if (item[0]?.label) {
                const mapData = item.map((i) => JSON.stringify(i))
                queryFilter[key] = mapData.join('|')
            } else {
                queryFilter[key] = item.join(',')
            }
        })
        return queryFilter
    }

    const onExport = () => {
        const { page, limit, ...queryRest } = queryList
        exportOrderList(queryRest, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Analytic-Order-Export-Start_${query?.start_date}-End_${query?.end_date}.xlsx`)
            setShowModal({ export: false })
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Analytic Order Exported',
            })
        })
    }

    const props = {
        dataComparison: orderComparison?.data,
        dataGraph: orderGraph?.data,
        dataList: orderList?.data,
        query,
        onChangeQuery,
        queryFilter,
        onFilter,
        modal,
        setShowModal,
        isLoadingComparison,
        isLoadingGraph,
        isLoadingList,
        isLoadingExport,
        onExport,
    }

    return <Order {...props} />
}
